import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import { Button } from 'components/qstrap'

const ListItem = ({
  id,
  name,
  description,
  url,
  currentUser,
  handleClick,
}) => {
  const downloadUrl = currentUser ? `/materials/${id}/download` : '#'

  return (
    <div className="material-list-item material-padding">
      <div className="material-list-item-left material-text-heading size-base p-b-md">
        {name}
      </div>
      <div className="material-list-item-middle material-text md-down-p-b-md md-up-p-r-md">
        {description}
      </div>
      <div className="material-list-item-right material-item-actions">
        { url && <Button tag="a" href={downloadUrl} onClick={e => handleClick(e)} color="campus" className="action-item">{intl.get('materials.download')}</Button> }
      </div>
    </div>
  )
}

ListItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string,
  currentUser: PropTypes.object,
  handleClick: PropTypes.func,
}

export { ListItem }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, ListItem)
